/**
 * <stone-information> — Shopify-product stone PDP wrapper.
 *
 * Exposes a `.data` object compatible with dyo-add.js's extractDiamondData()
 * so a Shopify-native moissanite (or future gemstone/diamond) PDP can plug
 * into the existing DYO flow without a MySQL roundtrip.
 *
 * Reads all fields from data-* attrs rendered by blocks/stone-information.liquid.
 */

if (!customElements.get('stone-information')) {
  class StoneInformation extends HTMLElement {
    connectedCallback() {
      const ds = this.dataset;
      const priceCents = parseInt(ds.price, 10);
      this.data = {
        id: ds.variantId,
        variantId: ds.variantId,
        handle: ds.handle,
        title: ds.title || '',
        price: Number.isFinite(priceCents) ? priceCents : ds.price,
        image: ds.image || '',
        sku: ds.sku || ds.variantId,
        carat: ds.carat || null,
        color: ds.color || null,
        clarity: ds.clarity || null,
        cut: ds.cut || null,
        shape: ds.shape || null,
        stone_type: (ds.stoneType || '').toLowerCase(),
        category: (ds.stoneCategory || '').toLowerCase(),
        source: 'shopify',
      };
    }
  }
  customElements.define('stone-information', StoneInformation);
}
